// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons

function EducationCard({ education }) {
    return (
      <div className="local-theme-bg-md local-theme-border-md shadow-lg rounded-lg p-6 border border-gray-200 flex items-start space-x-4">
        {/* Institution Logo */}
        <img
          src={education.logo}
          alt={education.institution}
          className="w-12 h-12 object-contain rounded-md"
        />
  
        {/* Education Details */}
        <div>
          <h2 className="text-lg font-semibold local-theme-text-md">{education.institution}</h2>
          <p className="local-theme-text-sm text-sm">
            {education.degree}, {education.field}
          </p>
          <p className="local-theme-text-xs text-xs mt-2">{education.duration}</p>
        </div>
      </div>
    );
  }
  
  export default EducationCard;